module.exports = __webpack_public_path__ + "img/base_activites_paintball.3f95836f.svg";